const CURRENT_URL = location.href;

const KNOWN_QUERY_PARAMS = [
    [["debug", "lcp"], "Open LCP debugger"],
    [["debug", "cls"], "Open CLS debugger"],
    [["debug", "inp"], "Open INP debugger"],
    [["debugld", "cwvchecklist"], "Open CWV checlist"],
    [["debugld", "showbtests"], "Show available Btests"],
    [
        ["debugld", "stickybtest"],
        "Make current btest sticky (only works if query param is already on the URL)",
    ],
    [["debugld", "serversidetimings"], "Render serverside timings overlay"],
    [["debugld", "showcomponents"], "Render components overlay"],
];

function makeQueries(queryInfo) {
    const [params, description] = queryInfo;
    const [paramName, paramValue] = params;

    const url = new URL(CURRENT_URL);
    const search = url.searchParams;
    if (search.has(paramName)) {
        const currentValue = search.get(paramName);
        if (currentValue.includes(paramValue)) {
            return;
        }
        const valuePieces = currentValue.split(",");
        valuePieces.push(paramValue);
        const newValue = valuePieces.join(",");
        search.set(paramName, newValue);
    } else {
        search.set(paramName, paramValue);
    }

    url.search = `?${search.toString()}`;

    console.log(
        `%c${description} ${url.href}`,
        "font-size: 1em; color: white; font-weight: bold; background: black;"
    );
}

export default function technicalHelper(_context) {
    console.log(`%c<RMTools>`, "font-size: 2em; color: CornflowerBlue; background: black;");
    KNOWN_QUERY_PARAMS.forEach(makeQueries);
    console.log(`%c</RMTools>`, "font-size: 2em; color: CornflowerBlue; background: black;");
}
